import React, { useState, useEffect } from 'react';
import { forwardRef } from 'react';
import Grid from '@material-ui/core/Grid';
import MaterialTable from '@material-table/core';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ExportCsv, ExportPdf } from '@material-table/exporters';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

// http://localhost:3000/#/subsea?organization=90&location=112&t=97b18e67-4914-424c-ac8f-f8ef3dfd7b46&exclude=[%22112112511%22,%22112112619%22,%22112113028%22,%22112113327%22,%22112113488%22]

const Subsea = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orgId = queryParams.get('organization');
  const locId = queryParams.get('location');
  const { token } = useAuth();
  const exclusions = queryParams.get('exclude');
  const asseturl = `https://eu-api.empathicbuilding.com/v1/organizations/${orgId}/locations/${locId}/assets?type=desk`;
  const api = axios.create({
    baseURL: 'https://eu-api.empathicbuilding.com/v1',
    headers: { Authorization: `Bearer ${token}` },
  });

  var columns = [
    { title: 'id', field: 'id' },
    { title: 'Name', field: 'name' },
    { title: 'Department', field: 'department' },
  ];
  const [data, setData] = useState([]);

  useEffect(() => {
    api
      .get(asseturl)
      .then((res) => {
        let responseData = res.data;
        console.log(responseData);
        if (exclusions !== null) {
          let floors = JSON.parse(exclusions);
          let result = [];
          result = responseData.filter((el) => {
            return !floors.find((element) => {
              return element === el.parent_id;
            });
          });
          console.log(result);
          setData(result);
        } else {
          setData(responseData);
        }
      })
      .catch((error) => {
        console.log('Error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#4caf50',
      },
      secondary: {
        main: '#ff9100',
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <div style={{ width: '99%' }} className="SubseaApp">
        <Grid container spacing={1} style={{ width: '100%' }}>
          <Grid item xs={3}></Grid>
          <Grid item xs={6}>
            {/*  <div>
              {iserror && (
                <Alert severity="error">
                  {errorMessages.map((msg, i) => {
                    return <div key={i}>{msg}</div>;
                  })}
                </Alert>
              )}
            </div> */}

            <h1>Desk allocation report</h1>
            <MaterialTable
              title="Desk allocation"
              columns={columns}
              data={data}
              icons={tableIcons}
              options={{
                exportMenu: [
                  {
                    label: 'Export CSV',
                    exportFunc: (cols, datas) =>
                      ExportCsv(cols, datas, 'Reservations_report'),
                  },
                  {
                    label: 'Export PDF',
                    //// You can do whatever you wish in this function. We provide the
                    //// raw table columns and table data for you to modify, if needed.
                    // exportFunc: (cols, datas) => console.log({ cols, datas })
                    exportFunc: (cols, datas) =>
                      ExportPdf(cols, datas, 'Reservations_report'),
                  },
                ],
              }}
            />
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
      </div>
    </MuiThemeProvider>
  );
};

export default Subsea;
